<template>
  <div>
    <div class="row justify-center">
      <div
        v-for="(patterns, bullish_or_bearish) in BulishBearishData"
        :key="bullish_or_bearish"
        :class="'col-12 q-ma-xs'"
      >
        <q-card flat bordered>
          <div
            class="text-subtitle1 text-bold q-pa-xs"
            :class="$q.dark.mode ? '' : 'text-primary'"
          >
            {{ bullish_or_bearish }}
          </div>
          <q-list bordered>
            <div class="row">
              <div
                :class="'col-6'"
                v-for="(pattern_info, pattern_name) in patterns"
                :key="pattern_name"
              >
                <q-card
                  flat
                  :bordered="!isSelected(pattern_name)"
                  @click="onClickCandleStickSignal(pattern_info, pattern_name)"
                  class="q-pa-xs q-ma-xs cursor-pointer"
                  :class="
                    $q.dark.mode
                      ? isSelected(pattern_name)
                        ? 'bg-grey-8 text-white'
                        : 'text-grey-4'
                      : isSelected(pattern_name)
                      ? 'bg-primary text-white'
                      : 'text-secondary'
                  "
                >
                  <div class="text-bold">
                    <span> {{ pattern_name }}: </span>
                    <span
                      class="q-pl-xs"
                      :class="
                        isSelected(pattern_name) ? 'text-white' : 'text-red'
                      "
                    >
                      {{ pattern_info.symbols.length }}</span
                    >
                  </div>
                </q-card>
              </div>
            </div>
          </q-list>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useQuasar } from "quasar";
const props = defineProps({
  BulishBearishData: {
    type: Object,
  },
});
const emit = defineEmits(["candleStickSignal"]);

const selectedPattern = ref(null);

const $q = useQuasar();

const onClickCandleStickSignal = (pattern_info, pattern_name) => {
  emit("candleStickSignal", pattern_info);
  selectedPattern.value = pattern_name;
};

const isSelected = (pattern_name) => {
  return selectedPattern.value === pattern_name;
};
</script>
